import * as React from "react";
import type { SVGProps } from "react";
const SvgIconChevronDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 12 12"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M.73 3.2q-.2.04-.3.24c-.02.06-.03.09-.03.17 0 .2-.24-.07 2.56 2.74L5.53 8.9q.22.15.51.14.24 0 .4-.12c.07-.05.7-.67 2.6-2.57 2.8-2.8 2.56-2.54 2.56-2.74 0-.08 0-.11-.03-.17-.11-.22-.36-.32-.59-.21-.04.02-.6.58-2.52 2.49L6 8.18 3.54 5.72c-1.9-1.9-2.48-2.47-2.52-2.49s-.16-.05-.2-.05q-.02 0-.09.02"
      fill="currentColor"
    />
  </svg>
);
export default SvgIconChevronDown;
